module.exports = __webpack_public_path__ + "static/media/futura-book.409b3efb.otf";